export enum SupplierDashboardView {
	list = 'LIST',
	grid = 'GRID',
}
